/**
 * Die erlaubten Vorsaetze (Praefixe) einer Feinbodenform mit ihrer Bedeutung.
 *
 * Der Vorsatz steht vor der Feinbodenform und sagt, wie der Oberboden veraendert
 * wurde. Er wird je Bodenglied einzeln gesetzt.
 *
 * Quelle der meisten Bedeutungen: SEA 95, Teil A, Abschnitt 8.10 „Veraenderungen
 * des Oberbodens", S. 237. `g` und `o` stehen dort nicht, gelten aber als gesichert
 * (Nutzer-Angabe 11.09.2026). Was niemand zweifelsfrei kennt, ist als `unsicher`
 * markiert und traegt ein Fragezeichen — geraten wird nichts.
 *
 * DIESE LISTE IST DIE EINZIGE STELLE mit den Klartexten. Welche Kuerzel erlaubt
 * sind, entscheidet weiterhin [FBF_PREFIX_REGEX](../../data-model.ts); dass beide
 * Listen dieselben Kuerzel fuehren, bewacht `fbf-praefixe.spec.ts`.
 */
export interface FbfPraefix {
	/** Das Kuerzel, so wie es eingegeben wird. */
	code: string;
	/** Klartext. Leer, solange niemand ihn zweifelsfrei kennt. */
	bedeutung: string;
	/** true = Bedeutung noch nicht gesichert, wird mit „?" gezeigt. */
	unsicher?: boolean;
}

export const FBF_PRAEFIXE: readonly FbfPraefix[] = [
	{ code: 'a', bedeutung: 'ausgetorft' },
	{ code: 'Ap', bedeutung: 'anthropogen-pflugerogen' },
	{ code: 'b', bedeutung: 'durch Ackerhochbeete nachhaltig verändert' },
	{ code: 'g', bedeutung: 'gekappt' },
	{ code: 'h', bedeutung: 'humusreich' },
	{ code: 'o', bedeutung: 'kolluvial beeinflusst' },
	{ code: 'p', bedeutung: 'plaggenbeeinflusst' },
	{ code: 'po', bedeutung: 'podsolig' },
	{ code: 'q', bedeutung: 'quellig', unsicher: true },
	{ code: 'rb', bedeutung: 'rabattiert' },
	{ code: 's', bedeutung: 'übersandet' },
	{ code: 'tp', bedeutung: 'tiefgepflügt' },
	{ code: 'w', bedeutung: '', unsicher: true },
	{ code: 'x', bedeutung: '', unsicher: true },
] as const;

/** Die Kuerzel als Aufzaehlung, z. B. fuer die Meldung bei falscher Eingabe. */
export function fbfPraefixCodes(): string {
	return FBF_PRAEFIXE.map(p => p.code).join(', ');
}
